export const getUTCDate = (timeInMs: number) => new Date(Date.now() + timeInMs).toUTCString();
